import React, { useState } from 'react';
// import Modal from 'react-modal'
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/I-CONTA.png';

import './navbar.css';

// Modal.setAppElement('#root')

const Menu = () => (
    <>
        <p><a href='#home'>Home</a></p>
        <p><a href='#avantaje'>Avantaje</a></p>
        <p><a href='#form'>Formular</a></p>
        <p><a href='#footer'>Contact</a></p>
    </>
)

const Navbar = () => {

    const navigate = useNavigate();
    const [toggleMenu, setToggleMenu] = useState(false);
    // const [modal, setModal] = useState(false);

    // const toggleModal = () => {
    //     setModal(!modal)
    // }

    return (
        <div className="iconta__navbar">
            <div className="iconta__navbar-links">
                <div className="iconta__navbar-links_logo">
                    <img src={logo} alt="logo" />
                </div>
                <div className="iconta__navbar-links_container">
                    <Menu />
                </div>
            </div>


            <div className="iconta__navbar-login">
                <button onClick={() => {navigate("/login")}} type="button">Login</button>
            </div>
                
                {/* {modal && (
                    <div className='modal'>
                        <div className='overlay' onClick={toggleModal}></div>
                            <div className='modal-content'>
                                <h2>hello</h2>
                                <p>teeeext</p>
                                <button className='close-modal' onClick={toggleModal}>CLOSE</button>
                            </div>
                    </div>
                )} */}

               
                
                {/* <Modal id='iconta__navbar-modal' isOpen={openModal} onRequestClose={()=>setOpenModal(false)}>
                    <div className='modal_background'>
                        <div className='modal_container'>
                            <button id='close_btn' onClick={() =>setOpenModal(false)}> X </button>
                            <disv className='title'>
                                <h1>Sign in</h1>
                            </div>
                            <div className='body'>
                                <p>formular</p>
                            </div>
                            <div className='footer'>
                                <button>Sign in</button>
                            </div>
                        </div>    
                    </div>
                </Modal> */}
            


            <div className='iconta__navbar-menu'>
                {toggleMenu
                    ? <RiCloseLine color='#fff' size={27} onClick={() => setToggleMenu(false)} />
                    : <RiMenu3Line color='#fff' size={27} onClick={() => setToggleMenu(true)} />
                }
                {toggleMenu && (
                    <div className='iconta__navbar-menu_container scale-up-center'>
                        <div className='iconta__navbar-menu_container-links'>
                            <Menu />
                            <div className="iconta__navbar-menu_container-links-login">
                                <button type="button">Login</button>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}

export default Navbar
